import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {useSelector} from 'react-redux'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import {EDIT_NOTES_FORM_INPUTS} from '../../../caregiver/ADD_NOTES_FORM_CONSTANTS'
import {Box, Typography, Button, TextField, FormControl} from '@mui/material'
import {toast} from 'react-toastify'
import {useHistory, useParams} from 'react-router-dom'
import dayjs from 'dayjs'
import DescriptionModal from '../../../../reusable-components/description-modal/descriptionmodal'
import NavigateButton from '../../../../reusable-components/description-modal/navigatebutton'
import {MoonLoader} from 'react-spinners'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'

const DeletedCaregiverNotesAssessmentForm = () => {
  const [formData, setFormData] = useState({})
  const [uiElementsList, setUiElementsList] = useState([])
  const [isFormLoading, setIsFormLoading] = useState(true)
  const [enableButtonText, setEnableButtonText] = useState('')
  const [inputArr, setInputArr] = useState([
    {
      taskId: '',
      taskName: '',
      taskDescription: '',
    },
  ])
  const params: {id: string} = useParams()
  const [clientid, setclientid] = useState()

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setIsFormLoading(true)
    try {
      // Fetch data
      const res = await axios.get(`/notes/getNoteById/${params.id}`)
      const program = res.data.programs.find((p) => p._id === res.data.programId)
      const client = res.data.clients.find((c) => c._id === res.data.clientId)
      const notesTasks = res.data.tasks || []

      setclientid(res.data.clientId)
      setInputArr(notesTasks)
      const prevFormData = formData

      // Set additional data
      prevFormData['noteType'] = res.data?.noteType
      prevFormData['programId'] = program ? program.programName : '' // program name
      prevFormData['clientId'] = client ? `${client.firstName} ${client.lastName}` : ''
      prevFormData['noteName'] = res.data?.noteName
      prevFormData['targetCompletionDate'] = res.data?.targetCompletionDate
      prevFormData['scoringMethod'] = res.data?.scoringMethod
      prevFormData['longTermObjectives'] = res.data?.longTermObjectives
      prevFormData['goals'] = res.data?.goals
      prevFormData['reasonForNotes'] = res.data?.reasonForNotes
      prevFormData['criteriaForCompletion'] = res.data?.criteriaForCompletion
      prevFormData['materialsRequired'] = res.data?.materialsRequired
      prevFormData['serviceId'] = res.data?.serviceId
      prevFormData['tasks'] = res.data?.tasks
      prevFormData['clientLivesWith'] = res.data?.clientLivesWith
      const descriptionCodeLists = res.data.services
      const serviceDescriptionList = descriptionCodeLists.map((description) => ({
        label: description.serviceDescription,
        value: description._id,
      }))
      setEnableButtonText(res.data.isApproved ? 'Disable' : 'Enable')

      const uiElements = EDIT_NOTES_FORM_INPUTS(serviceDescriptionList).map((item) => {
        if (item.type === 'CaregiverNotesDialog') {
          return {...item, disabled: true, isDisabled: true}
        }
        return {...item, disabled: true}
      })
      setFormData(prevFormData)
      setUiElementsList(uiElements)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setIsFormLoading(false)
    }
  }

  const buttons = [{label: 'Cancel', variant: 'outlined', type: 'button'}]

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormWrapper
        title='Deleted Caregiver Assessment'
        content={
          <>
            {isFormLoading ? (
              <div
                className='overlay d-flex align-middle justify-content-center align-middle'
                style={{marginTop: '100px'}}
              >
                <MoonLoader color='#9db2fc' size={60} loading={isFormLoading} />
              </div>
            ) : (
              <>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    marginLeft: '0.5rem',
                    marginRight: '0.5rem',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '0.1rem',
                      marginLeft: 'auto',
                    }}
                  ></Box>
                </Box>
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '0.5rem',
                    marginLeft: '1rem',
                  }}
                  color='primary'
                >
                  Note Type
                </Typography>
                <FrequencyDateRangePicker
                  isEntry={false}
                  isTemplate={true}
                  isFullForm={false}
                  isEdit={true}
                  formData={formData}
                  setFormData={setFormData}
                  isDeleted={true}
                />
                <DynamicForm
                  fields={uiElementsList}
                  data={formData}
                  onSubmit={() => {}}
                  buttons={buttons}
                  disabled={true}
                />
              </>
            )}
          </>
        }
      />
    </LocalizationProvider>
  )
}

export default DeletedCaregiverNotesAssessmentForm
